module.exports = __webpack_public_path__ + "static/media/004-feather-red.bef3c65e.svg";